module.exports = __webpack_public_path__ + "static/media/drink-me.2ee1fbb7.svg";